
// React Imports
import * as React from "react";
import {useState, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import {
    DataGrid,
} from '@mui/x-data-grid';
import Box from "@mui/material/Box";

import {
    Avatar,
    Tooltip
} from "@mui/material";

// App Imports
import {getCdpStatsMarketGroup} from "../../ContractDataPoint/ContractDataPointClient";
import CustomFooter from "../../CommonComponents/GridCustomFooter";
import {changeCdpStats} from "./cdpStatsSlice";
import {CdpStatsMenu} from "./CdpStatsMenu";


// main function
export default function MarketGroupCdpStatsGrid() {

    // ****************** BEGIN STATES ****************************

    const [marketGroupCdpStats, setMarketGroupCdpStats] = useState([]);
    const [gridVisible, setGridVisible] = React.useState(true);


    // ****************** END STATES ****************************


    // *********************** BEGIN STORE ********************************


    const hideActions = localStorage.getItem('hideActions') === "true";
    const dispatchData = useDispatch();

    // ********************** END STORE ********************************


    // ****************** BEGIN FETCH ****************************

    const fetchMarketGroupCdpStats = () =>
        getCdpStatsMarketGroup()

            .then(data => {
                console.log(data);
                setMarketGroupCdpStats(data);
            })
    useEffect(() => {
        fetchMarketGroupCdpStats();
    }, []);

    // ****************** END FETCH ****************************


    const renderMarketGroupCdpStats = marketGroupCdpStats => {
        if (marketGroupCdpStats.length <= 0) {
            return "No Data";
        }}


    // ****************** BEGIN CRUD ***********************************



    // ****************** END CRUD ***********************************



    // ****************** BEGIN DRILLDOWN ****************************

    // ****************** END DRILLDOWN ****************************

    const handleClickedRow = (marketGroupCdpStats) => {

        console.log('Stats data from clicked row');
        console.log(marketGroupCdpStats);
        dispatchData(changeCdpStats({marketGroupId: marketGroupCdpStats.marketGroupId, marketGroupName: marketGroupCdpStats.marketGroupName,
            releaseMarketId: null, releaseMarketName: null,
            seriesId: null, seriesName: null, seasonId: null, seasonName: null, productId: null, episodeName: null, photoStartDate: null,
            gridDisplay: "ReleaseMarketFullScreen"}));
    };





    // ****************** BEGIN COLUMNS ****************************

    const columns = marketGroupCdpStats => [

        {    field: 'more',
            headerName: '',
            description: '',
            sortable: true,
            width: 60,
            hide: false,
            renderCell: (params) => (
                <div onClick={(event) => event.stopPropagation()}>
                    <CdpStatsMenu row={params.row}  />
                </div>
            )
        },
        {    field: 'id',
            headerName: 'ID',
            description: '',
            sortable: true,
            width: 60,
            hide: true,
        },
        {
            field: 'mktGroupName',
            headerName: 'Market Group',
            description: '',
            sortable: true,
            editable: true,
            hide: false,
            // editable: true,
            width: 220,
        },
        {
            field: 'mktGroupId',
            headerName: 'Market Group ID',
            description: '',
            sortable: false,
            editable: false,
            width: 100,
            hide: true,
        },
        {
            field: 'participantsCount',
            headerName: 'Participants',
            width: 100,
            headerAlign: 'center',
            renderCell: (marketGroupCdpStats) => {
                const count = marketGroupCdpStats.row.participantsCount;

                if (count === 0 || count === null || count === undefined) return "";

                // Calculate width based on digit count
                const digitCount = count.toString().length;
                const width = 20 + (digitCount - 1) * 10; // Start at 20, add 10px per extra digit

                return (
                    <Box sx={{
                        width: "100%",
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        <Tooltip title="Count of guild contracts.">
                            <Avatar variant="rounded" sx={{
                                height: 20,
                                width,
                                fontSize: 16,
                                backgroundColor: "rgb(30,144,255)",
                                color: "rgb(255, 255, 255)"
                            }}>
                                {count}
                            </Avatar>
                        </Tooltip>
                    </Box>
                );
            }
        },

        {
            field: 'residualsCount',
            headerName: 'Guilds',
            width: 100,
            headerAlign: 'center',
            renderCell: (marketGroupCdpStats) => {
                const count = marketGroupCdpStats.row.residualsCount;

                if (count === 0 || count === null || count === undefined) return "";

                // Calculate width based on digit count
                const digitCount = count.toString().length;
                const width = 20 + (digitCount - 1) * 10; // Start at 20, add 10px per extra digit

                return (
                    <Box sx={{
                        width: "100%",
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        <Tooltip title="Count of guild contracts.">
                            <Avatar variant="rounded" sx={{
                                height: 20,
                                width,
                                fontSize: 16,
                                backgroundColor: "rgb(30,144,255)",
                                color: "rgb(255, 255, 255)"
                            }}>
                                {count}
                            </Avatar>
                        </Tooltip>
                    </Box>
                );
            }
        },
        {
            field: 'standAloneCount',
            headerName: 'Stand Alone',
            width: 100,
            headerAlign: 'center',
            renderCell: (marketGroupCdpStats) => {
                const count = marketGroupCdpStats.row.standAloneCount;

                if (count === 0 || count === null || count === undefined) return "";

                // Calculate width based on digit count
                const digitCount = count.toString().length;
                const width = 20 + (digitCount - 1) * 10; // Start at 20, add 10px per extra digit

                return (
                    <Box sx={{
                        width: "100%",
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        <Tooltip title="Count of stand alone products with contracts.">
                            <Avatar variant="rounded" sx={{
                                height: 20,
                                width,
                                fontSize: 16,
                                backgroundColor: "rgb(30,144,255)",
                                color: "rgb(255, 255, 255)"
                            }}>
                                {count}
                            </Avatar>
                        </Tooltip>
                    </Box>
                );
            }
        },
        {
            field: 'seriesCount',
            headerName: 'Series',
            headerAlign: 'center',
            width: 100,
            renderCell: (marketGroupCdpStats) => {
                const count = marketGroupCdpStats.row.seriesCount;

                if (count === 0 || count === null || count === undefined) return "";

                // Calculate width based on digit count
                const digitCount = count.toString().length;
                const width = 20 + (digitCount - 1) * 10; // Start at 20, add 10px per extra digit

                return (
                    <Box sx={{
                        width: "100%",
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        <Tooltip title="Count of series with contracts.">
                            <Avatar variant="rounded" sx={{
                                height: 20,
                                width,
                                fontSize: 16,
                                backgroundColor: "rgb(30,144,255)",
                                color: "rgb(255, 255, 255)"
                            }}>
                                {count}
                            </Avatar>
                        </Tooltip>
                    </Box>
                );
            }
        },
        // {
        //     field: 'seasonCount',
        //     headerName: 'Seasons',
        //     headerAlign: 'center',
        //     width: 100,
        //     renderCell: (marketGroupCdpStats) => {
        //         const count = marketGroupCdpStats.row.seasonCount;
        //
        //         if (count === 0 || count === null || count === undefined) return "";
        //
        //         // Calculate width based on digit count
        //         const digitCount = count.toString().length;
        //         const width = 20 + (digitCount - 1) * 10; // Start at 20, add 10px per extra digit
        //
        //         return (
        //             <Box sx={{
        //                 width: "100%",
        //                 display: 'flex',
        //                 alignItems: 'center',
        //                 justifyContent: 'center'
        //             }}>
        //                 <Tooltip title="Count of seasons with contracts.">
        //                     <Avatar variant="rounded" sx={{
        //                         height: 20,
        //                         width,
        //                         fontSize: 16,
        //                         backgroundColor: "rgb(30,144,255)",
        //                         color: "rgb(255, 255, 255)"
        //                     }}>
        //                         {count}
        //                     </Avatar>
        //                 </Tooltip>
        //             </Box>
        //         );
        //     }
        // },
        // {
        //     field: 'episodeCount',
        //     headerName: 'Episodes',
        //     headerAlign: 'center',
        //     width: 100,
        //     renderCell: (marketGroupCdpStats) => {
        //         const count = marketGroupCdpStats.row.episodeCount;
        //
        //         if (count === 0 || count === null || count === undefined) return "";
        //
        //         // Calculate width based on digit count
        //         const digitCount = count.toString().length;
        //         const width = 20 + (digitCount - 1) * 10; // Start at 20, add 10px per extra digit
        //
        //         return (
        //             <Box sx={{
        //                 width: "100%",
        //                 display: 'flex',
        //                 alignItems: 'center',
        //                 justifyContent: 'center'
        //             }}>
        //                 <Tooltip title="Count of episodes with contracts.">
        //                     <Avatar variant="rounded" sx={{
        //                         height: 20,
        //                         width,
        //                         fontSize: 16,
        //                         backgroundColor: "rgb(30,144,255)",
        //                         color: "rgb(255, 255, 255)"
        //                     }}>
        //                         {count}
        //                     </Avatar>
        //                 </Tooltip>
        //             </Box>
        //         );
        //     }
        // },
        // {
        //     field: 'products',
        //     headerName: 'Products',
        //     headerAlign: 'center',
        //     width: 100,
        //     renderCell: (marketGroupCdpStats) => {
        //         const count = marketGroupCdpStats.row.productCount;
        //
        //         if (count === 0 || count === null || count === undefined) return "";
        //
        //         // Calculate width based on digit count
        //         const digitCount = count.toString().length;
        //         const width = 20 + (digitCount - 1) * 10; // Start at 20, add 10px per extra digit
        //
        //         return (
        //             <Box sx={{
        //                 width: "100%",
        //                 display: 'flex',
        //                 alignItems: 'center',
        //                 justifyContent: 'center'
        //             }}>
        //                 <Tooltip title="Count of episodes with contracts.">
        //                     <Avatar variant="rounded" sx={{
        //                         height: 20,
        //                         width,
        //                         fontSize: 16,
        //                         backgroundColor: "rgb(30,144,255)",
        //                         color: "rgb(255, 255, 255)"
        //                     }}>
        //                         {count}
        //                     </Avatar>
        //                 </Tooltip>
        //             </Box>
        //         );
        //     }
        // },


        {
            field: 'distinctOwedStatus',
            headerName: 'Owed Status',
            description: '',
            sortable: true,
            editable: false,
            hide: false,
            // editable: true,
            width: 150,
        },
        {
            field: 'owedSumDisplay',
            headerName: 'Owed',
            description: '',
            sortable: true,
            editable: false,
            hide: false,
            align: 'right', // aligns cell content
            headerAlign: 'right', // optional: aligns header text too
            // editable: true,
            width: 120,
        },
        {
            field: 'distinctPaymentStatus',
            headerName: 'Payment Status',
            description: '',
            sortable: true,
            editable: false,
            hide: false,
            // editable: true,
            width: 150,
        },
        {
            field: 'paymentSumDisplay',
            headerName: 'Payment',
            description: '',
            sortable: true,
            editable: false,
            align: 'right', // aligns cell content
            headerAlign: 'right', // optional: aligns header text too
            hide: false,
            // editable: true,
            width: 120,
        },
        {
            field: 'fringeSumDisplay',
            headerName: 'Fringe',
            description: '',
            sortable: true,
            editable: false,
            align: 'right', // aligns cell content
            headerAlign: 'right', // optional: aligns header text too
            hide: false,
            // editable: true,
            width: 120,
        },
        {
            field: 'taxSumDisplay',
            headerName: 'Tax',
            description: '',
            sortable: true,
            editable: false,
            align: 'right', // aligns cell content
            headerAlign: 'right', // optional: aligns header text too
            hide: false,
            // editable: true,
            width: 120,
        },
        {
            field: 'expenseSumDisplay',
            headerName: 'Expense',
            description: '',
            sortable: true,
            editable: false,
            align: 'right', // aligns cell content
            headerAlign: 'right', // optional: aligns header text too
            hide: false,
            // editable: true,
            width: 120,
        },
        // {
        //     field: 'approvedCount',
        //     headerName: 'Approved',
        //     width: 100,
        //     headerAlign: 'center',
        //     renderCell: (marketGroupCdpStats) => {
        //         const count = marketGroupCdpStats.row.approvedCount;
        //
        //         if (count === 0 || count === null || count === undefined) return "";
        //
        //         // Calculate width based on digit count
        //         const digitCount = count.toString().length;
        //         const width = 20 + (digitCount - 1) * 10; // Start at 20, add 10px per extra digit
        //
        //         return (
        //             <Box sx={{
        //                 width: "100%",
        //                 display: 'flex',
        //                 alignItems: 'center',
        //                 justifyContent: 'center'
        //             }}>
        //                 <Tooltip title="Count of approved contracts.">
        //                     <Avatar variant="rounded" sx={{
        //                         height: 20,
        //                         width,
        //                         fontSize: 16,
        //                         backgroundColor: "rgb(30,144,255)",
        //                         color: "rgb(255, 255, 255)"
        //                     }}>
        //                         {count}
        //                     </Avatar>
        //                 </Tooltip>
        //             </Box>
        //         );
        //     }
        // },
        // {
        //     field: 'unapprovedCount',
        //     headerName: 'Unapproved',
        //     width: 100,
        //     headerAlign: 'center',
        //     renderCell: (marketGroupCdpStats) => {
        //         const count = marketGroupCdpStats.row.unapprovedCount;
        //
        //         if (count === 0 || count === null || count === undefined) return "";
        //
        //         // Calculate width based on digit count
        //         const digitCount = count.toString().length;
        //         const width = 20 + (digitCount - 1) * 10; // Start at 20, add 10px per extra digit
        //
        //         return (
        //             <Box sx={{
        //                 width: "100%",
        //                 display: 'flex',
        //                 alignItems: 'center',
        //                 justifyContent: 'center'
        //             }}>
        //                 <Tooltip title="Count of unapproved contracts.">
        //                     <Avatar variant="rounded" sx={{
        //                         height: 20,
        //                         width,
        //                         fontSize: 16,
        //                         // backgroundColor: "rgb(30,144,255)",
        //                         backgroundColor: "warning.main",
        //                         color: "rgb(255, 255, 255)"
        //                     }}>
        //                         {count}
        //                     </Avatar>
        //                 </Tooltip>
        //             </Box>
        //         );
        //     }
        // },

    ];

    // ****************** END COLUMNS ****************************


    // ****************** BEGIN TOOLBAR ****************************



    // ****************** END TOOLBAR ****************************

    // ****************** BEGIN RETURN ****************************

    return (
        <div style={{ height:800 , width: '100%' }}>
            <Box sx={{height: 70, pt: 1, pl: 3}}>
                <h3>Made-For Market Group Current Issuance Version Statistics</h3>
            </Box>
            {gridVisible && <DataGrid
                experimentalFeatures={{ newEditingApi: true }}
                initialState={{
                }}
                style={{cursor: 'pointer'}}
                aria-label={"MarketGroupCdpStats"}
                rows={marketGroupCdpStats}
                disableDensitySelector={true}
                disableColumnSelector={true}
                columns={columns(fetchMarketGroupCdpStats)}
                onRowClick = {(marketGroupCdpStats)=>handleClickedRow(marketGroupCdpStats.row)}
                density={"compact"}
                pageSize={20}
                rowsPerPageOptions={[20]}
                rowKey={marketGroupContractStat => marketGroupContractStat.id}
                components={{
                    // Toolbar: CustomToolbar,
                    Footer: CustomFooter,
                }}
            />}
        </div>
    );

    // ****************** END RETURN ****************************

}

